import { Result } from '~/core/results/types/results.type';

export const getResultTitleFromH1 = (result: Result): string | null => {
    if (!result.h1) {
        return null;
    }
    if (
        Array.isArray(result.h1) &&
        result.h1.length > 0 &&
        result.h1[0] &&
        typeof result.h1[0] === 'string' &&
        result.h1[0].length > 0
    ) {
        return result.h1[0];
    }
    if (typeof result.h1 === 'string' && result.h1.length > 0) {
        return result.h1;
    }
    return null;
};

const getResultTitle = (result: Result): string => {
    const title = getResultTitleFromH1(result) || result.title;
    if (title) {
        return title;
    }
    return '';
};

export default getResultTitle;
